import { render } from "./ubuntu_body_banner2.vue?vue&type=template&id=14cb4741&scoped=true"
import script from "./ubuntu_body_banner2.vue?vue&type=script&lang=js"
export * from "./ubuntu_body_banner2.vue?vue&type=script&lang=js"

import "./ubuntu_body_banner2.vue?vue&type=style&index=0&id=14cb4741&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14cb4741"]])

export default __exports__